<div hidden>
  <input type="file" id="fileUpload" (change)="selectFile($event)" accept=".xlsx">
</div>

<div hidden>
  <input type="file" id="attachmentUpload" (change)="selectAttachment($event)">
</div>


<mat-toolbar class="claims-module custom-toolbar">
  <mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />
  <mat-toolbar-row class="mat-elevation-z6">
    <span>Claims</span>
    <span class="example-spacer"></span>

    <div class="example-button-row">

      @if (this.isSupplier || this.isCustomer || this.isPNE) {
        <button mat-raised-button color="primary"
          [disabled]="!enableEdit()" (click)="openEditDialog()">
          <mat-icon>edit</mat-icon>Edit
        </button>
      }

      <button mat-raised-button color="primary" (click)="proceed('accept')" [disabled]="!enableProceed()">
        <mat-icon>done_outline</mat-icon>{{ this.selection.selected.length == 1 && this.selection.selected[0].claim_status === 'CR' ? 'Release' : 'Accept'}}
      </button>

      <button mat-raised-button color="primary" (click)="proceed('reject')" [disabled]="!enableCancel()">
        <mat-icon>cancel</mat-icon>{{ this.selection.selected.length == 1 && this.selection.selected[0].claim_status === 'CR' ? 'Delete' : 'Reject'}}
      </button>

      <button mat-raised-button color="primary" (click)="export()">
        <mat-icon>cloud_download</mat-icon> Export
      </button>

      <button mat-raised-button color="primary" [disabled]="this.selection.selected.length == 0"
        (click)="openHistoryDialog()">
        <mat-icon>history</mat-icon> History
      </button>

      <button mat-raised-button color="primary" [disabled]="this.selection.selected.length == 0"
        (click)="showAttachments()">
        <mat-icon>attachment</mat-icon> Show attachments
      </button>

      @if (this.isAdmin) {
        <button mat-raised-button color="primary" (click)="showSelectFileDialog()">
          <mat-icon>cloud_upload</mat-icon> Upload
        </button>
      }
    </div>

  </mat-toolbar-row>
  <mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />

</mat-toolbar>

<app-my-loader />

<mat-card class='claims-module'>


  <table>
    <tr>
      <td valign="top">
        <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>search</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="clearFilters()">All records</button>
          @for (filter of filters; track filter) {
            <button mat-menu-item (click)="applySavedFilter(filter?.id)" (contextmenu)="filterClick($event, filter.id)">
              <mat-icon [style.color]="filter?.color">label</mat-icon>
              {{filter?.search_name}}
            </button>
          }
        </mat-menu>
      </td>

      <td>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Search options:
            </mat-panel-title>
            <mat-panel-description>
              <div [hidden]="panelOpenState">
                {{searchData}}
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <table>
            <tr>
              <td style="width: 30%">
                <mat-form-field style="width: 100%;">
                  <mat-label>Claim No.</mat-label>
                  <input [(ngModel)]="claimNo" matInput
                    (keyup.enter)="refreshList()">
                  </mat-form-field>
                </td>
                <td>
                  <mat-card class="mat-elevation-z0">
                    <mat-card-subtitle>Status:
                      <button class="small-btn" (click)="allStatuses(true)">
                        <mat-icon>check</mat-icon>
                      </button>
                      <button class="small-btn" (click)="allStatuses(false)">
                        <mat-icon>clear</mat-icon>
                      </button>
                    </mat-card-subtitle>
                    <mat-card-content>
                      @if (this.isCustomer) {
                        <mat-checkbox [(ngModel)]="isCR" title="created">CR</mat-checkbox>
                      }
                      <mat-checkbox [(ngModel)]="isNW" title="New">NW</mat-checkbox>
                      <mat-checkbox [(ngModel)]="isACGA" title="Accepted by the GA Supplier, awaiting Production Engineer confirmation">AC-GA</mat-checkbox>
                      <mat-checkbox [(ngModel)]="isACP" title="Accepted by the GA Supplier, awaiting document correction">AC-P</mat-checkbox>
                      <mat-checkbox [(ngModel)]="isRJGA" title="Rejected by the GA Supplier, awaiting customer confirmation">RJ-GA</mat-checkbox>
                      <mat-checkbox [(ngModel)]="isAC" title="Accepted" (change)="statusAdjust()">AC</mat-checkbox>
                      <mat-checkbox [(ngModel)]="isRJ" title="Rejected" (change)="statusAdjust()">RJ</mat-checkbox>
                    </mat-card-content>
                  </mat-card>
                </td>
                <td>
                  <mat-form-field style="width: 65%;">
                    <mat-label>Order No.</mat-label>
                    <input [(ngModel)]="orderNo" matInput
                      (keyup.enter)="refreshList()">
                    </mat-form-field>
                    <mat-form-field style="margin-left:10px; width: 30%;">
                      <mat-label>Order Line No.</mat-label>
                      <input [(ngModel)]="orderLineNo" matInput
                        (keyup.enter)="refreshList()">
                      </mat-form-field>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <lf-select-search [listElements]="suppliers" placeholder="GA Supplier (No. / Name)"
                        placeholderLabel="search supplier" (selected)="supplierChanged($event)"
                        [selectedElementId]="supplierId" />
                    </td>

                    <td>
                      <lf-select-search [listElements]="customers" placeholder="Customer (No. / Name)"
                        placeholderLabel="search customer" (selected)="customerChanged($event)"
                        [selectedElementId]="customerId" />
                    </td>

                    <td>
                      <lf-select-search [listElements]="items" placeholder="Item" placeholderLabel="item"
                        (selected)="itemChanged($event)" [selectedElementId]="itemId" />
                    </td>

                  </tr>
                  <tr>
                    <td colspan="2">
                      Created date from

                      <mat-form-field style="margin-left:10px; margin-right:10px; width: 140px;">
                        <mat-label>Date from</mat-label>
                        <input matInput [matDatepicker]="picker1"
                          [(ngModel)]="dateFrom" [value]="dateFrom">
                          <mat-datepicker-toggle matSuffix [for]="picker1" />
                          <mat-datepicker #picker1 [(ngModel)]="dateFrom" ngDefaultControl />
                        </mat-form-field>

                        to

                        <mat-form-field style="margin-left:10px; margin-right:10px; width: 140px;">
                          <mat-label>Date to</mat-label>
                          <input matInput [matDatepicker]="picker2" [(ngModel)]="dateTo"
                            [value]="dateTo">
                            <mat-datepicker-toggle matSuffix [for]="picker2" />
                            <mat-datepicker #picker2 [(ngModel)]="dateTo" ngDefaultControl />
                          </mat-form-field>
                        </td>

                        <td align="right">
                          <button mat-button (click)="refreshList()">
                            <mat-icon class="button-bar-icon">check</mat-icon> Apply
                          </button>

                          <button mat-button (click)="clearFilters()">
                            <mat-icon class="button-bar-icon">clear</mat-icon> Clear
                          </button>

                          <button mat-button (click)="openSaveSearchDialog()">
                            <mat-icon class="button-bar-icon">save</mat-icon> Save search
                          </button>
                        </td>
                      </tr>
                    </table>
                  </mat-expansion-panel>
                </td>
              </tr>
            </table>


            <mat-card>
              <table width="100%">
                <tr>
                  <td width="50%">
                    <mat-form-field>
                      <mat-label>Filter</mat-label>
                      <input matInput [(ngModel)]="filterText" (keyup)="applyFilter($event.target.value)">
                    </mat-form-field>
                  </td>
                  <td align="right">
                    <mat-checkbox [(ngModel)]="showClosed" (change)="showHideClosed()">Show closed claims</mat-checkbox>
                  </td>
                </tr>
              </table>

              <div class="grid-claims grid-container mat-elevation-z8">
                <table mat-table #table1 [dataSource]="dataSource" matSort matSortActive="claim_no" matSortDirection="desc">

                  <ng-container matColumnDef="select" sticky>
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="$event ? masterToggle($event) : null"
                        [checked]="selection.hasValue() && isEntirePageSelected()"
                        [indeterminate]="selection.hasValue() && !isEntirePageSelected()" />
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)" />
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="claim_no" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Claim No. </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.claim_no?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="claim_status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Claim status </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.claim_status?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="created_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Created date </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + ((row.created_date | date: 'yyyy-MM-dd') ?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="fy">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> FY </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.fy?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="order_no">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Order No. </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.order_no?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="order_line_no">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Line No. </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.order_line_no?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="customer_no">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer No. </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.customer_no?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="customer_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.customer_name?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="supplier_no">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> GA Supplier No. </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.supplier_no?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="supplier_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> GA Supplier </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.supplier_name?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="item_no">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Item No. </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.item_no?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="item_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Item Name </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.item_name?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="dispatched_qty">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Dispatched qty </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.dispatched_qty?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="claimed_qty">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Claimed qty </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.claimed_qty?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="claim_reason_code">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Claim reason code </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.claim_reason_codes?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="claimed_cost">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Claimed cost </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.claimed_cost?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="manual_claimed_cost">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Manual claimed cost </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.manual_claimed_cost?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="currency">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Currency </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.currency?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="safety_alarm">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Safety alarm </th>
                    <td mat-cell *matCellDef="let row" style="text-align: center">
                      @if (row.safety_alarm) {
                        <mat-icon color="warn">warning</mat-icon>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="suggested_actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Suggested actions </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.suggested_actions?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="customers_comments">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer comments </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.customers_comments?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="suppliers_comments">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> GA Supplier comments </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.suppliers_comments?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="customer_attachments">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer attachments </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.customer_attachments?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="supplier_attachments">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> GA Supplier attachments </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.supplier_attachments?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="last_update_dt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Latest update date </th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.last_update_dt?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <ng-container matColumnDef="last_update_user_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Latest update user name</th>
                    <td mat-cell *matCellDef="let row" [innerHTML]="'<div>' + (row.last_update_user_name?? '') + '</div>' | highlightSearch: filterText"></td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                  </tr>

                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    (dblclick)="$event.ctrlKey ? null : openEditDialog(row);"
                    (click)="$event.ctrlKey ? checkTableRow(row) : null"
                    [class.highlight]="selection.isSelected(row)">
                  </tr>

                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" class="mat-paginator-sticky" />
              </div>
            </mat-card>

          </mat-card>
